import { useMemo } from "react";

import { values } from "lodash";

import { FormControl, InputLabel, Select, Typography } from "@mui/material";

import { useAppConfigQuery } from "#/features/User/queries";
import { StaffShift } from "@/api";
import { darkGray } from "@/common/theming/colors";
import { showStatusForUnit } from "@/common/utils/shifts";

import { NoteUpdateTag } from "../../NoteUpdateTag/NoteUpdateTag";
import { MenuItem } from "../../TrackedComponents";
import { TShiftEditorProps } from "../types";

export const StatusPicker = (props: TShiftEditorProps) => {
  const { staffShift, updateStaffShift, unitOfShift, readonly } = props;

  const allAvailableUnits = useAppConfigQuery().data?.accessibleUnits;
  const selectedUnit = allAvailableUnits?.find(({ id }) => id === unitOfShift.id);
  const statusesToShow = useMemo(
    () =>
      values(StaffShift.EStatus).filter(
        (status) => status === staffShift.status || showStatusForUnit(status, selectedUnit),
      ),
    [selectedUnit, staffShift.status],
  );
  return (
    <FormControl
      className={`status-picker ${staffShift.status ? "has-status" : "no-status"}`}
      fullWidth
      size={"small"}
    >
      <InputLabel id="status-picker-label" shrink>
        Status
      </InputLabel>
      <Select<StaffShift.EStatus | "">
        id="status-picker-select"
        size={"small"}
        readOnly={readonly}
        label="Status"
        labelId="status-picker-label"
        disabled={readonly}
        value={staffShift.status || ""}
        displayEmpty
        onChange={(event) => {
          updateStaffShift({
            ...staffShift,
            status: (event.target.value as StaffShift.EStatus) || null,
          });
        }}
      >
        <MenuItem value={""} key="update-notes-update-option-empty" trackingLabel={null}>
          <Typography fontSize="13px" color={darkGray} className="no-status">
            <i>No status</i>
          </Typography>
        </MenuItem>
        {Object.values(statusesToShow).map((status) => (
          <MenuItem
            value={status}
            key={"update-notes-update-option-" + status}
            trackingLabel={null}
          >
            <NoteUpdateTag update={status} sx={{ p: 0.2, px: 0.5 }} unitId={unitOfShift.id} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
